
export const types = {
    login: 'login',
    register: 'register',
    logout: 'logout',
    productLoad: '[Producto] Load product',
    productActive: '[Producto] Active productos'
}

export const typesArticulo = {
    resgister: 'register',
    artUpdate: 'actualizar',
    artDelete: 'eliminar'
}